<template>
  <div class="security-notice" v-if="shouldShow">
    <a-alert
      type="error"
      message="本平台为联网平台，请勿上传涉密文件"
      banner
      :show-icon="false"
      class="notice-content"
    />
  </div>
</template>

<script setup lang="ts">
import { Alert as AAlert } from "ant-design-vue";
import { useRoute } from "vue-router";
import { computed } from "vue";

const route = useRoute();
const shouldShow = computed(() => {
  const allowedRoutes = ["/login", "/authorize"];
  return allowedRoutes.includes(route.path);
});
</script>

<style scoped>
.security-notice {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.notice-content {
  margin: 0;
  text-align: center;
  font-weight: 500;
}

.notice-content :deep(.ant-alert-message) {
  color: #ff4d4f;
}
</style>
